import pick from 'transmute/pick';
import { createReducer } from '@reduxjs/toolkit';
import { fetchSettings, saveModifiedSettings } from '../actions/SettingsActions';
import { ALL_USER_ATTRIBUTE_KEYS } from '../constants/UserAttributesKeys';
const initialState = {};

// Example state:
// {
//   // from 'task-forms-lib/constants/RelativeDates'
//   [USER_ATTRIBUTE_DEFAULT_DUE_DATE_PRESET]: 'oneWeek',
//   // number of minutes after midnight
//   [USER_ATTRIBUTE_DEFAULT_DUE_TIME]: 480,
//   [USER_ATTRIBUTE_HIDE_FOLLOW_UP_TASKS]: true
// }

const persistentSettingsReducer = createReducer(initialState, builder => {
  builder.addCase(fetchSettings.fulfilled, (state, action) => {
    return pick(ALL_USER_ATTRIBUTE_KEYS, action.payload);
  }).addCase(saveModifiedSettings.fulfilled, (state, action) => {
    return Object.assign({}, state, action.payload);
  });
});
export default persistentSettingsReducer;